// extracted by mini-css-extract-plugin
export default {"root":"PopConfirm_root__oCawq"};